import React, { useEffect, useState } from 'react';
import { Result, Button, Card, Spin, message } from 'antd';
import { CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState<'success' | 'pending' | 'failed'>('pending');

  useEffect(() => {
    checkPaymentStatus();
  }, []);

  const checkPaymentStatus = async () => {
    try {
      const orderId = searchParams.get('out_trade_no');
      if (!orderId) {
        setPaymentStatus('failed');
        setLoading(false);
        return;
      }

      // 查询订单状态
      const response = await api.get(`/payment/rainbow/order-status/${orderId}`);
      const order = response.data;

      if (order.status === 'completed') {
        setPaymentStatus('success');
        message.success('支付成功！');
      } else if (order.status === 'pending') {
        setPaymentStatus('pending');
        // 继续轮询检查状态
        setTimeout(checkPaymentStatus, 3000);
      } else {
        setPaymentStatus('failed');
      }
    } catch (error) {
      console.error('检查支付状态失败:', error);
      setPaymentStatus('failed');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <Spin 
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} 
          tip="正在确认支付状态..."
        />
      </div>
    );
  }

  if (paymentStatus === 'success') {
    return (
      <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title="支付成功！"
          subTitle="您的订单已支付成功，服务器正在创建中，请稍后查看。"
          extra={[
            <Button type="primary" key="dashboard" onClick={() => navigate('/dashboard')}>
              返回控制台
            </Button>,
            <Button key="servers" onClick={() => navigate('/servers')}>
              查看服务器
            </Button>,
          ]}
        />
      </div>
    );
  }

  if (paymentStatus === 'pending') {
    return (
      <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
        <Result
          icon={<LoadingOutlined style={{ fontSize: 64, color: '#1890ff' }} />}
          title="支付处理中..."
          subTitle="我们正在确认您的支付，请稍候。"
          extra={[
            <Button type="primary" key="refresh" onClick={checkPaymentStatus}>
              刷新状态
            </Button>,
            <Button key="dashboard" onClick={() => navigate('/dashboard')}>
              返回控制台
            </Button>,
          ]}
        />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <Result
        status="error"
        title="支付失败"
        subTitle="支付过程中出现问题，请重试或联系客服。"
        extra={[
          <Button type="primary" key="retry" onClick={() => navigate('/servers/create')}>
            重新购买
          </Button>,
          <Button key="dashboard" onClick={() => navigate('/dashboard')}>
            返回控制台
          </Button>,
        ]}
      />
    </div>
  );
};

export default PaymentSuccess;



